import fetch from "auth/FetchInterceptor";

const SummaryService = {};

SummaryService.index = function (params) {
  // Construct query string from params object
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");

  return fetch({
    url: `/summary?${queryString}`,
    method: "get",
  });
};

export default SummaryService;
